/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { useTranslator } from '@front-activerse/common-components';
import { Container, Row, Col, Alert } from 'reactstrap';
import ShoppingListSearch from './Search/ShoppingListSearch';
import ShoppingListContent from './Content/ShoppingListContent';
import { createDateObject } from '@front-activerse/common-components';
import MarkProductProvider from './MarkProduct/MarkProductProvider';

import 'array-flat-polyfill';

const ShoppingListContainer = ({
  shoppingList,
  handleMarkProduct,
  period: initialPeriod,
  fetchShoppingListOnDemand,
  loadingOnDemand,
  shoppingTipsArticleId,
}) => {
  const { trackFirebaseEvent } = useOutletContext();
  const [period, setPeriod] = useState({
    start: initialPeriod.start.substring(0, 10),
    end: initialPeriod.end.substring(0, 10),
  });
  const [periodCoverage, setPeriodCoverage] = useState(false);

  useEffect(() => {
    const startDate = shoppingList.period.start;
    const endDate = shoppingList.period.end;

    if (!loadingOnDemand) {
      if (
        new Date(period.end) > new Date(endDate) ||
        new Date(period.start) < new Date(startDate)
      ) {
        setPeriodCoverage(true);
      } else {
        setPeriodCoverage(false);
      }
    }
  }, [shoppingList]);

  const { t } = useTranslator();

  useEffect(() => {
    trackFirebaseEvent('screen_view', {
      firebase_screen: 'ShoppingList',
    });
  }, [trackFirebaseEvent]);

  const handlePeriodChange = async (newPeriod) => {
    await fetchShoppingListOnDemand(newPeriod);

    const { start: startString, end: endString } = newPeriod;
    const start = createDateObject(startString);
    const end = createDateObject(endString);

    const length = Math.ceil((end - start) / 1000 / 60 / 60 / 24) + 1;

    trackFirebaseEvent('user_action', {
      action: 'tap-show_shopping_list',
      location: 'ShoppingList',
      shopping_list_days: length,
    });
  };

  return (
    <Container className="py-md-4">
      <Row>
        <Col xl={{ size: 10, offset: 1 }}>
          <div className="page-container">
            <ShoppingListSearch
              handlePeriodChange={handlePeriodChange}
              period={period}
              setPeriod={setPeriod}
            />

            <div className="shopping-list-container">
              {shoppingList.categories.length > 0 ? (
                <MarkProductProvider handleMarkProduct={handleMarkProduct}>
                  <ShoppingListContent
                    periodCoverage={periodCoverage}
                    categories={shoppingList.categories}
                    start={shoppingList.period.start}
                    end={shoppingList.period.end}
                    loading={loadingOnDemand}
                    shoppingTipsArticleId={shoppingTipsArticleId}
                  />
                </MarkProductProvider>
              ) : (
                <Alert color="danger">
                  <p className="small">{t('shoppingList.notification.noMealPlan')}</p>
                </Alert>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export { ShoppingListContainer };

export default ShoppingListContainer;
